import { config } from "./config";
import { tataNeuFaqs } from "./partner_faqs/tata_faqs";
import { FAQ } from "./static_faqs/types";

export const clientLogoDescriptions = {
  "visit-health": "Fitcoin Store",
};

export const CSS_FILES = {
  default: "/styles/main.css",
  lazypay: "/styles/lazypay.css",
  "lazypay-mock": "/styles/lazypay.css",
  "mock-niyo": "/styles/mobikwik.css",
};

export function getCSSFile(clientIdPrefix: string): string {
  if (clientIdPrefix in CSS_FILES) {
    return CSS_FILES[clientIdPrefix as keyof typeof CSS_FILES];
  }

  return CSS_FILES.default;
}

export const FONTS = {
  default: [
    "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Krona+One&display=swap",
  ],
  rnr: ["https://fonts.googleapis.com/css2?family=Sacramento&display=swap"],
  sdk: [
    {
      "mock-niyo":
        "https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900&display=swap",
    },
  ],
};

export const BRAND_L2_SUMMARY_DISCOUNT_LABEL = {
  default: "Base discount",
  lazypay: "Lazypay discount",
  "lazypay-mock": "Lazypay discount",
  stoofers: "Stoofers discount",
};

export function getBrandL2SummaryLabel(clientIdPrefix: string): string {
  if (clientIdPrefix in BRAND_L2_SUMMARY_DISCOUNT_LABEL) {
    return BRAND_L2_SUMMARY_DISCOUNT_LABEL[
      clientIdPrefix as keyof typeof BRAND_L2_SUMMARY_DISCOUNT_LABEL
    ];
  }

  return BRAND_L2_SUMMARY_DISCOUNT_LABEL.default;
}

type ClientIdConfig = {
  axisClientId: string;
  tdClientId: string;
  bajajClientId: string;
  godrejPropertiesClientId: string;
  moneycontrolClientId: string;
  kotakClientId: string;
  onePercentClientId: string;
  stooferClientId: string;
  raisoniClientId: string;
  momentsRnrClientId: string;
  redeemHubbleClientId: string;
  brenClientId: string;
};

const CLIENT_ID_CONFIGS: Record<string, ClientIdConfig> = {
  prod: {
    axisClientId: "axisbank-llE1XBk0",
    raisoniClientId: "raisoni-A8Aa6FsT",
    tdClientId: "tata-digital-HmS62avt",
    bajajClientId: "bajajfinserv-CyyetFBG",
    godrejPropertiesClientId: "godrej-properties-rnr-FsDd6dSt",
    moneycontrolClientId: "moneycontrol-2lABGigG",

    kotakClientId: "kotak-client-id-placeholder", // TODO: remove this
    onePercentClientId: "one-percent-v2-0MAtl8AH",
    stooferClientId: "stoofers-1F9eGgKR",
    momentsRnrClientId: "demo-hubble-c5m2Dvjd",
    redeemHubbleClientId: "redeem-hubble-wUk8BaJg",
    brenClientId: "bren-client-id-placeholder",
  },
  nonProd: {
    axisClientId: "acme-code-3241c2c1",
    raisoniClientId: "raisoni-dev",
    tdClientId: "tata-digital-23gvn314",
    bajajClientId: "bajaj-code-Bp3sxUCw",
    godrejPropertiesClientId: "godrej-properties-rnr-LEj5WNL5",
    moneycontrolClientId: "moneycontrol-QH53rltu",

    kotakClientId: "kotak-sdk",
    onePercentClientId: "onepercent",
    stooferClientId: "stoofers-oPExjdmx",
    momentsRnrClientId: "acme-3241c2c1",
    redeemHubbleClientId: "redeem-hubble-059mzyEK",
    brenClientId: "bren-I9Up5fKI",
  },
};

export const clientIdConfig =
  config.env === "Prod" ? CLIENT_ID_CONFIGS.prod : CLIENT_ID_CONFIGS.nonProd;

export function accomodateHigherBrandsPerRowOnHomeForCodeBasedPortal(
  clientId?: string
): boolean {
  // true only for td client
  return clientId === clientIdConfig.tdClientId;
}

export function isCustomCoinInputEnabled(clientId?: string): boolean {
  return (
    clientId === clientIdConfig.kotakClientId ||
    clientId === clientIdConfig.brenClientId
  );
}

export function shouldShowCoinDiscountAsPercentage(clientId?: string): boolean {
  return !!clientId && clientId === clientIdConfig.onePercentClientId;
}

export function showHubbleBrandingOnVoucherCard(clientId?: string): boolean {
  return clientId != clientIdConfig.stooferClientId;
}

export function isDarkThemeEnabledForSdkClient(clientId: string): boolean {
  return (
    clientId === clientIdConfig.onePercentClientId ||
    clientId === clientIdConfig.stooferClientId
  );
}

export function showHelpAndSupportFAQsTab(clientId?: string): boolean {
  return clientId != clientIdConfig.stooferClientId;
}

export function getPartnerFaqs(clientId?: string): FAQ[] | null {
  if (clientId === clientIdConfig.tdClientId) {
    return tataNeuFaqs;
  }

  return null;
}
